import { ValidationResponse } from "@/components/google-map/helpers/validateProjectSize"
import { GeometryIntersectionResultItem } from "@/components/google-map/types"
import { ReportPageMode } from "@/pages/create-app/summary-report/SummaryReport"
import { createContext, Dispatch, SetStateAction, useContext } from "react"

export type QuoteData = {
  areasIntersectionsCheckResult: Maybe<GeometryIntersectionResultItem[]>
}

type DefaultValues = {
  isReportMode: boolean
  setIsReportMode: Dispatch<SetStateAction<boolean>>
  itemId: Maybe<string>
  setItemId: Dispatch<SetStateAction<Maybe<string>>>
  geometryInfo: ValidationResponse | null
  setGeometryInfo: Dispatch<SetStateAction<ValidationResponse | null>>
  pageModeGlobal: ReportPageMode
  setPageModeGlobal: Dispatch<SetStateAction<ReportPageMode>>
  createQuoteData: QuoteData | null
  setCreateQuoteData: Dispatch<SetStateAction<QuoteData | null>>
  loginEmail: Maybe<string>
  setLoginEmail: Dispatch<SetStateAction<Maybe<string>>>
  orgIds: Maybe<string[]>
  setOrgIds: Dispatch<SetStateAction<Maybe<string[]>>>
  currentLink: Maybe<string>
  setCurrentLink: Dispatch<SetStateAction<Maybe<string>>>
  currentDeliveryIds: string[]
  setCurrentDeliveryIds: Dispatch<SetStateAction<string[]>>
}

export const defaultValues: DefaultValues = {
  isReportMode: false,
  setIsReportMode: () => null,
  itemId: null,
  setItemId: () => null,
  geometryInfo: null,
  setGeometryInfo: () => null,
  pageModeGlobal: "default",
  setPageModeGlobal: () => null,
  createQuoteData: null,
  setCreateQuoteData: () => null,
  loginEmail: null,
  setLoginEmail: () => null,
  orgIds: null,
  setOrgIds: () => null,
  currentLink: "",
  setCurrentLink: () => null,
  currentDeliveryIds: [],
  setCurrentDeliveryIds: () => null,
}
const GlobalContext = createContext(defaultValues)
const useGlobalContext = (): DefaultValues => useContext(GlobalContext)

export { GlobalContext, useGlobalContext }
